<template>
  <v-chip small :color="config.color" :text-color="config.textColor" label>
    <v-icon left x-small>{{ config.icon }}</v-icon>
    {{ label || config.label }}
  </v-chip>
</template>

<script>
/**
 * Semáforo de salud para los bloques del reporte de sistema
 * (`ok` | `degraded` | `error`).
 */
const STATUS_MAP = {
  ok: {
    label: 'Operativo', color: 'green lighten-4', textColor: 'green darken-4', icon: 'mdi-check-circle',
  },
  degraded: {
    label: 'Degradado', color: 'orange lighten-4', textColor: 'orange darken-4', icon: 'mdi-alert',
  },
  error: {
    label: 'Con fallas', color: 'red lighten-4', textColor: 'red darken-4', icon: 'mdi-close-circle',
  },
};

export default {
  name: 'HealthStatusChip',
  props: {
    status: { type: String, default: 'ok' },
    label: { type: String, default: '' },
  },
  computed: {
    config() {
      return STATUS_MAP[this.status] || {
        label: this.status || 'Desconocido',
        color: 'grey lighten-3',
        textColor: 'grey darken-2',
        icon: 'mdi-help-circle',
      };
    },
  },
};
</script>
